module.exports = __webpack_public_path__ + "img/dcom02.c1edf891.png";